<app-card-table [info]="info" (infoIsToggled)="eventTriggered($event)"></app-card-table>